export const normalizePhone = (phone: string = ''): string => {
  return phone.replace(/\D/g, '');
};

export const validatePhone = (phone: string = ''): boolean => {
  const normalizedPhone = normalizePhone(phone);

  return normalizedPhone.length === 11 || normalizedPhone.length === 12;
};
